<!-- =========================================================================================
    File Name: ChartBarChart.vue
    Description: Create bar chart
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->
<template>

<!-- <vx-card title="Statistiques" class="mb-base">
    <div class="flex flex-wrap gap-4 mt-5">
      <div class="flex-1 min-w-[300px]">
        <h5>{{$t('letters_monthly_trend_table')}}</h5>
        <chartjs-component-bar-chart :height="150"></chartjs-component-bar-chart>
      </div>
      <div class="flex-1 min-w-[300px]">
        <h5>{{$t('letters_monthly_trend_table_entrepise')}}</h5>
        <chartjs-component-bar-chart2 :height="150"></chartjs-component-bar-chart2>
      </div>
    </div>
  </vx-card> -->
    <vx-card title="Statistiques" class="mb-base" >
        <div class="mt-5">
            <h5>{{$t('letters_monthly_trend_table')}}</h5>
            <chartjs-component-bar-chart :height="150"></chartjs-component-bar-chart>
        </div>

        <div class="mt-5">
          <h5>{{$t('letters_monthly_trend_table_entrepise')}}</h5>

            <chartjs-component-bar-chart2 :height="150"></chartjs-component-bar-chart2>
        </div>
    </vx-card>
</template>

<script>
import ChartjsComponentBarChart from './ChartjsComponentBarChart.vue'
import ChartjsComponentBarChart2 from './ChartjsComponentBarChart2.vue'

export default {
  components: {
    ChartjsComponentBarChart,
    ChartjsComponentBarChart2
  }
}
</script>
